<template>
  <div>
    <h2 class="form__title">Регистрация <span class="form__title-part-separated">Шаг 4 из 6</span></h2>
    <h3 class="form__subtitle">Подтверждение E-mail</h3>
    <div class="form__description form__description_align-center">
      <p>Мы отправили на&nbsp;почту <strong>{{ emailToUnicode }}</strong> письмо для&nbsp;подтверждения электронного адреса. Для&nbsp;продолжения регистрации пройдите по&nbsp;ссылке из&nbsp;письма.</p>
      <p>Если вы не&nbsp;получили письмо, проверьте папку "Спам", воспользуйтесь повторной отправкой или&nbsp;напишите в&nbsp;<a href="/feedback" target="_blank" class="form__link">Службу поддержки</a>.</p>
    </div>
    <div class="form-row form-row_align-center">
      <a href="#" class="button button__lg button__blue" @click.prevent="sendAgain">Запросить новое письмо</a>
    </div>
    <div class="form-row form-row_align-center">
      <a href="#" class="button button__lg button__blue" @click.prevent="openEmailChangeModal">Изменить мой E-mail</a>
    </div>
    <div class="form__description form__description_align-center">
      <p>Если письмо не приходит, вы можете запросить его повторно</p>
    </div>
    <div class="form__description form__description_align-center">
      <delete-questionnaire-btn />
    </div>

    <sign-up-step-email-change-modal
      :opened="emailChangeModalOpened"
      :email="emailToUnicode"
      @close="closeEmailChangeModal"
      @change-email="handleEmailChange"
    />
  </div>
</template>

<script>
import api from "../services/api";
import SignUpStepEmailChangeModal from "./SignUpStepEmailChangeModal.vue";
import { toUnicode } from "../utils";

export default {
  name: "SignUpStepEmailConfirm",
  components: {SignUpStepEmailChangeModal},
  props: {
    email: {type: String, required: true}
  },
  data() {
    return {
      emailChangeModalOpened: false,
    }
  },
  mounted() {
    this.sendAgain();
  },
  methods: {
    async sendAgain() {
      this.$store.dispatch("showLoader");
      try {
        await api.simplePostSuccess('/api/sendEmailConfirmationCode');
      } catch (e) {
        this.$store.dispatch("setErrors", e);
      } finally {
        this.$store.dispatch("hideLoader");
      }
    },
    openEmailChangeModal() {
      this.emailChangeModalOpened = true;
    },
    closeEmailChangeModal() {
      this.emailChangeModalOpened = false;
    },
    handleEmailChange(email) {
      this.$emit('change-email', email);
      this.sendAgain();
    }
  },
  computed: {
    emailToUnicode() {
      return toUnicode(this.email);
    }
  }
}
</script>
